import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IStepTree, TError } from './types/step-tree-interface';
import { fetchStepTree } from './action/fetch-step-tree';

const initialState: IStepTree = {
    Agree: false,
    Price: 0,
    Uid: '',
    Paylink: '',
    Polis: '',
    isLoading: false,
    error: [],
};

export const StepTreeSlice = createSlice({
    name: 'StepTreeSlice',
    initialState,
    reducers: {
        resetStepTreeSlice: (state) => {
            state.Price = 0;
            state.Uid = '';
            state.isLoading = false;
            state.error = [];
            state.Paylink = '';
        },
        updateField: (state, action: PayloadAction<{ field: keyof IStepTree; value: IStepTree[keyof IStepTree] }>) => {
            const { field, value } = action.payload;
            state[field] = value as never;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchStepTree.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchStepTree.fulfilled, (state, action: PayloadAction<{ price: number, uid: string, paylink: string, polis: string }>) => {
                state.Price = action.payload.price;
                state.Uid = action.payload.uid;
                state.Paylink = action.payload.paylink;
                state.Polis = action.payload.polis
                state.isLoading = false;
                state.error = [];
            })
            .addCase(fetchStepTree.rejected, (state, action) => {
                state.Price = initialState.Price;
                state.Uid = initialState.Uid;
                state.Paylink = initialState.Paylink;
                state.Polis = initialState.Polis;
                state.isLoading = false;
                state.error = action.payload as TError;
            })
    },
});

export const { resetStepTreeSlice, updateField } = StepTreeSlice.actions;
export default StepTreeSlice.reducer;
